import {HomepageHeaderArenaSkeletonDefaultBox} from "./home-page-header-arena-skeleton.default.box";
import {styledByTheme} from "../../../../../themes/architecture/styled-by-theme";
import {HomepageHeaderArenaSkeletonSIBox} from "./home-page-header-arena-skeleton.si.box";

export const HomepageHeaderArenaSkeletonBox = styledByTheme(HomepageHeaderArenaSkeletonDefaultBox)
    .forSI(HomepageHeaderArenaSkeletonSIBox)
    .apply();
